{{ hash }} · {{ builtAt }} UTC
